import { createClient } from '../client';

export const getTitle = async (id: string) => {
  const supabaseClient = createClient();

  // SUPABASE: Call backend fn instead of sb directly
  const { data, error } = await supabaseClient
    .from('searches')
    .select('title')
    .eq('id', id)
    .maybeSingle();
  if (error) throw error;
  return data?.title;
};
